import React, { Component, Fragment } from 'react'; 
import DispatchProps from '../../../utils/DispatchProps';
import { connect } from "react-redux";
import { IRootState } from '../../../store';
import LinkCard from '../../LinkCard';
import SchoolPageTitle from '../../SchoolPageTitle';
import AdminSchoolMenu from '../../AdminSchoolMenu';

interface SchoolCustomerMenuPageProps {
    tenantId: string;
    schoolCode: string;
}

interface SchoolCustomerMenuPageState {
}

class SchoolCustomerMenuPage extends Component<SchoolCustomerMenuPageProps & DispatchProps, SchoolCustomerMenuPageState> {

    constructor(props: SchoolCustomerMenuPageProps & DispatchProps) {
        super(props)
        this.state = {
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<SchoolCustomerMenuPageProps & DispatchProps>, prevState: Readonly<SchoolCustomerMenuPageState>, snapshot?: any): Promise<void> {

    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Customer Tools Menu" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <div className={"flex-row"}>
                    <LinkCard
                        title={"Assignment Analytics"}
                        to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/assignment-analytics-overview`}
                        iconName={"Chart"}
                        description={"Access Assignment Analytics"}
                    />
                    <LinkCard
                        title={"Class Drop Ins"}
                        to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/cover-manager`}
                        iconName={"PeopleRepeat"}
                        description={"Access Drop Ins (cover manager)"}
                    />
                </div>
                <div className={"flex-row"}>
                    <LinkCard
                        title={"Customer Data Page"}
                        to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/school-subject-data`}
                        iconName={"ExploreData"}
                        description={"Access Customer Data Page"}
                    />
                    <LinkCard
                        title={"Customer Access Page"}
                        to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/school-access`}
                        iconName={"Contact"}
                        description={"Access Customer Access Page"}
                    />
                </div>
                <div className={"flex-row"}>
                    <LinkCard
                        title={"Assignment Search"}
                        to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/student-assignment-search`}
                        iconName={"DocumentSearch"}
                        description={"Access Assignment Search"}
                    />
                    <LinkCard
                        title={"Rollover Form"}
                        to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/rollover/form/${(new Date()).getFullYear()}`}
                        iconName={"DateTime2"}
                        description={"Customer view of the rollover form"}
                    />
                </div>
            </Fragment>
        )
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any }): SchoolCustomerMenuPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
        };
    }
)(SchoolCustomerMenuPage)